import type { AssetMetadataV2Lookup } from '@infinex/asset-config';
import { makeCacheKey } from '@infinex/asset-config';

export const dedupeAssetMetadataLookups = (
  lookups: AssetMetadataV2Lookup[]
): AssetMetadataV2Lookup[] => {
  const seen = new Set<string>();
  return lookups.filter((lookup) => {
    const cacheKey = makeCacheKey(lookup);
    if (seen.has(cacheKey)) return false;
    seen.add(cacheKey);
    return true;
  });
};
